import React, { useEffect, useState, useContext } from "react";
import { HeaderHeading } from "../../../../Context";
import organisms from "../../../../components/organisms";
import Wrapper from "../../../../components/common/Wrapper/Wrapper";
import service from "../../../../api/services";
import { useToasts } from 'react-toast-notifications';
import constant from "../../../../constants/constant";
import { generatePdfHeader } from '../../../../constants/utils'
import { RTGetBarcodeData, TReportData } from "./interface";
import { useBarcodeReport } from "./hook";

const { BarcodeAuditTrail } = organisms

const Index = () => {
    const { generatePdfFromData,fetchArrayBuffer,triggerDownload,xlsToJson,getCleanPathFromResponse  } = useBarcodeReport()
    const { setHeader, setSidebar }: any = useContext(HeaderHeading);
    const [barcodeAuditData, setBarcodeAuditData]= useState<[]>([])
    const [reportData, setReportData] = useState<TReportData>({
        barcode: NaN,
        report_format: NaN
    })
    const { addToast } = useToasts();

    const getBarcodeId = async (barcode: number):Promise<RTGetBarcodeData[]> => {
        try {
            let barcodeResponse = await service.reportService.barcodeSearch({ search: barcode })
            return barcodeResponse?.data?.data
        } catch (error) {
            console.error(error)
            return []
        }
    }

    const handleSubmit = async () => {
        try {
            const barcodeIds = await getBarcodeId(reportData?.barcode);
            if (!barcodeIds || barcodeIds.length !== 1) throw new Error();
    
            const payload = { barcodes: [barcodeIds[0]?.id] };
            const response = await service.reportService?.barcodeAuditTrail(payload);
            if (response.status !== 200) throw new Error();
    
            const cleanPath = getCleanPathFromResponse(response?.data?.data)
            let fileName = cleanPath.substring(cleanPath.lastIndexOf("/") + 1);
    
            if (reportData?.report_format === constant?.DailyReportFormat[0].value) {
                const xlsData = await fetchArrayBuffer(cleanPath);
                const jsonData = xlsToJson(xlsData);
                generatePdfHeader(jsonData, 4, "barcode_audit_trail_report", "Specxweb");
            }
    
            if (reportData?.report_format === constant?.DailyReportFormat[1].value) {
                setTimeout(async () => {
                    const blob = await (await fetch(cleanPath)).blob();
                    triggerDownload(blob, fileName);
                }, 2000);
            }
        } catch (error: any) {
            const errorMessage = error?.response?.data?.message || "There is empty data";
            addToast(errorMessage, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    };
    
    const handleView = async () => {
        try {
            const barcodeIds = await getBarcodeId(reportData?.barcode);
            if (!barcodeIds || barcodeIds.length !== 1) throw new Error();
    
            const payload = { barcodes: [barcodeIds[0]?.id] };
            const response = await service.reportService?.barcodeAuditTrail(payload);
            if (response.status !== 200) throw new Error();
    
            const cleanPath = getCleanPathFromResponse(response?.data?.data)
            const xlsData = await fetchArrayBuffer(cleanPath);
            const jsonData = xlsToJson(xlsData);
    
            setBarcodeAuditData(generatePdfFromData(jsonData, 4));
        } catch (error: any) {
            const errorMessage = error?.response?.data?.message || "There is empty data";
            addToast(errorMessage, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    };
    

    const handleChange = (name: string, value: number) => {
        setReportData({ ...reportData, [name]: value })
    }


    useEffect(() => {
        setHeader("Report - Barcode Audit Trail")
    }, [])


    return (
        <Wrapper>
            <BarcodeAuditTrail
                handleChange={(name: string, value: number) => handleChange(name, value)}
                reportData={reportData}
                handleSubmit={() => handleSubmit()}
                handleView={() => handleView()} 
                barcodeAuditData={barcodeAuditData}/>
        </Wrapper>
    )
}

export default Index